import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { urlUtility } from "@repo/utilities/url.utility.ts";

export const useGetSingleConfiguredClaimService = () => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const claimId = +urlQueries["claim-id"] || "";
  const singleConfiguredClaimService = useQuery({
    queryKey: [...CACHE_KEYS.CONFIGURED_CLAIMS, claimId],
    queryFn: () => {
      return handleGlobalGetRequestQuery({
        url: `${URLS?.CONFIGURED_CLAIMS}/1`,
      });
    },
  });
  return {
    service: { singleConfiguredClaimService },
  };
};
